/* Well and Glow: one-tap add for the cart add-ons row (snippets/wg-cart-addons.liquid). */
(function () {
  if (window.wgCartAddonsReady) return;
  window.wgCartAddonsReady = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wgca-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var drawer = btn.closest('cart-drawer');
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';
    var body = { items: [{ id: parseInt(btn.getAttribute('data-wgca-add'), 10), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add this item');
        if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
          var line = (res.j.items && res.j.items[0]) || {};
          res.j.id = line.variant_id || line.id;
          drawer.renderContents(res.j);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        var li = btn.closest('.wgca__item');
        if (li && !li.querySelector('.wgca__err')) {
          var p = document.createElement('p');
          p.className = 'wgca__err';
          p.setAttribute('role', 'alert');
          p.textContent = err.message;
          li.appendChild(p);
        }
      });
  });
})();
